import { createSlice } from '@reduxjs/toolkit'
import {
  getContragents,
  saveContragent,
  createContragent,
  deleteContragent,
} from './contragentActions'

const initialState = {
  contragents: [],
  loading: false,
  error: false,
  loadingError: false,
  savingError: false,
  saving: false,
  saved: false,
  savedContragent: {},
  deleting: false,
  deleted: false,
  deletingError: false,
  loaded: false,
}

function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}

const contragentsSlice = createSlice({
  name: 'contragents',
  initialState,
  reducers: {
    clear: (state) => {
      state.saved = false
      state.savingError = false
      state.loadingError = false
      state.savedContragent = {}
      state.deleting = false
      state.deleted = false
      state.deletingError = false
      state.loaded = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getContragents.fulfilled, (state, { payload }) => {
        state.loading = false
        state.contragents = payload
        state.loaded = true
      })
      .addCase(getContragents.pending, (state) => {
        state.loading = true
        state.error = null
        state.loaded = false
      })
      .addCase(saveContragent.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(saveContragent.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.contragents[state.contragents.findIndex((p) => p.id === payload.id)] = payload
        state.savedContragent = payload
        state.saved = true
        state.saving = false
      })
      .addCase(saveContragent.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(createContragent.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(createContragent.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedContragent = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createContragent.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(deleteContragent.pending, (state) => {
        state.deleting = true
        state.deletingError = null
        state.deleted = false
      })
      .addCase(deleteContragent.fulfilled, (state) => {
        state.deletingError = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deleteContragent.rejected, (state, { payload }) => {
        state.deleting = false
        state.deletingError = payload
        state.deleted = false
      })
      .addMatcher(
        isRejectedAction,
        // `action` will be inferred as a RejectedAction due to isRejectedAction being defined as a type guard
        (state, { payload }) => {
          state.loading = false
          state.error = payload
          state.loaded = false
        },
      )
  },
})
export const { clear } = contragentsSlice.actions
export default contragentsSlice.reducer
